;/* jarvis-under-sink-legacy-redirect-asset-20260513 */
(function () {
  try {
    var target = '/products/cozy-haven-2-tier-pull-out-cabinet-organizer';
    var legacy = {
      '/products/cozy-haven-2-tier-bamboo-dish-drying-rack': true,
      '/products/cozy-haven-2-tier-pull-out-under-sink-organizer': true
    };
    if (legacy[window.location.pathname]) {
      window.location.replace(target + window.location.search + window.location.hash);
    }
  } catch (error) {}
})();
(function () {
  var config = window.CozyAnalyticsConfig || {};
  var dataLayer = window.dataLayer = window.dataLayer || [];

  function loadScript(src) {
    if (!src || document.querySelector('script[src="' + src + '"]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  function ensureGTM(id) {
    if (!id || window.__cozyGTMLoaded) return;
    window.__cozyGTMLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
    loadScript('https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id));
  }

  function ensureGA4(id) {
    if (!id || window.__cozyGA4Loaded || config.gtmId) return;
    window.__cozyGA4Loaded = true;
    loadScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id));
    window.gtag = window.gtag || function(){ dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { send_page_view: true });
  }

  function ensureMetaPixel(id) {
    if (!id || window.fbq) return;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(
      window, document,'script','https://connect.facebook.net/en_US/fbevents.js'
    );
    window.fbq('init', id);
    window.fbq('track', 'PageView');
  }

  ensureGTM(config.gtmId);
  ensureGA4(config.ga4Id);
  ensureMetaPixel(config.metaPixelId);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (window.fbq) window.fbq('track', 'AddToCart');
  });
})();
window.__jarvisAssetProbe='20260412-probe';
